import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import React, { useContext } from 'react'
import ImageList from './ImageList'
import { UploadContext } from 'global/cnr/contexts/UploadContext';
import _ from 'lodash'
import ImageDropzone from './ImageDropzone';
import { fileStatusTypes } from 'global/cnr/reducers/UploadReducer';

const _imageProps = {
  list: {
    size: 'huge'
  },
  appUser: {
    imageSize: 'tiny',
    floated: 'right',
    iconSize: 'big'
  }
}

export const BulkFiles = ({ selectedItem, callback_imageFiles, allowImageDisplay }) => {

  const uploadContext = useContext(UploadContext)
  const { upload_state, upload_handlers } = uploadContext ?? {}
  const { files_info, storageType, } = upload_state ?? {}

  const { selectedFolderFiles, unSelectedFiles, pendingFiles } = files_info ?? {}

  const handleImageClick = (file) => {
    const _pendingFiles = _.cloneDeep(pendingFiles);
    if (_pendingFiles[selectedItem]) {
      const { name: name_file } = file ?? {}
      // Create deep copies to avoid mutating state directly 
      _.forEach(_pendingFiles, (pf) => {
        const { file: file_pending } = pf
        const { name: name_pending } = file_pending ?? {}
        if (name_file === name_pending) {
          pf.file = null
          pf.fileStatusType = fileStatusTypes.missing
        }
      })
      _pendingFiles[selectedItem].fileStatusType = fileStatusTypes.approved
      _pendingFiles[selectedItem].file = file
      upload_handlers && upload_handlers.handleUpdate_pendingFiles(_pendingFiles)
    }
  }

  const upload_dropzone = () => <ImageDropzone
    storageType={storageType}
    forMulti={true}
    noImageDisplay={allowImageDisplay ? false : true}
    callback_imageFiles={callback_imageFiles}
  />

  const folderList = () => <ImageList
    listItems={unSelectedFiles}
    selectedItem={selectedItem}
    _imageProps={_imageProps}
    parentItems={pendingFiles}
    oc={handleImageClick}
  />

  const folderListWrapper = () => <Wrapper
    content={selectedFolderFiles ? folderList() : <div></div>}
    footer={upload_dropzone()}
    wrapperType={wrapperTypes.paddedFooter}
  />

  return folderListWrapper()
}
